export default "__VITE_ASSET__BlFkT$Ei__"